export default __webpack_public_path__ + "static/media/logoSingle.632d0817.svg";